import { type LabelComponentType, getLabelComponent } from "../../../../common-deprecated/components/label/Label";
import {
    type GetLabelType,
    type GetOptionalLabelType,
    type UseLabelType,
    type UseOptionalLabelType,
    getLabelFn,
    getOptionalLabelFn,
    getUseLabel,
    getUseOptionalLabel,
} from "../../../../common-deprecated/hooks/useLabel";
import type { CarConfigStateType } from "../redux/store";
import type { CommonSettingsType } from "../../../../common-deprecated/settings/fetchCommonSettings";
import type { CarConfigSettingsType } from "../redux/slices/CarConfigSettingsSlice";

import type { CarConfigLabelType } from "./labels";

type CarConfigLabelParamType = Partial<
    Record<
        | "title"
        | "count"
        | "pack"
        | "price"
        | "pricemode"
        | "weeks"
        | "searchValue"
        | "amount"
        | "otherFilters"
        | "tyreName"
        | "setPartNumber"
        | "primaryPrice"
        | "secondaryPrice"
        | "from"
        | "until"
        | "packs"
        | "engine"
        | "model"
        | "newGrade"
        | "currentGrade"
        | "item"
        | "colour"
        | "wheel"
        | "upholstery"
        | "homecharger"
        | "extra"
        | "financeProductName"
        | "eprel",
        string | number
    >
>;
type CarConfigLabelStateType = {
    commonSettings: CommonSettingsType;
    carConfigSettings: CarConfigSettingsType;
};
export const useCarConfigLabel = getUseLabel(
    (state: CarConfigStateType) => state.carConfigSettings.labels,
    (state: CarConfigStateType) => !!state.commonSettings.query.showDictionaryKeys,
) as UseLabelType<CarConfigLabelType, CarConfigLabelParamType>;
export const useCarConfigOptionalLabel = getUseOptionalLabel(
    (state: CarConfigStateType) => state.carConfigSettings.labels,
    (state: CarConfigStateType) => !!state.commonSettings.query.showDictionaryKeys,
) as UseOptionalLabelType<CarConfigLabelType, CarConfigLabelParamType>;
export const getCarConfigLabel = getLabelFn(
    (state: CarConfigLabelStateType) => state.carConfigSettings.labels,
    (state: CarConfigLabelStateType) => !!state.commonSettings.query.showDictionaryKeys,
) as GetLabelType<CarConfigLabelStateType, CarConfigLabelType, CarConfigLabelParamType>;
export const getCarConfigOptionalLabel = getOptionalLabelFn(
    (state: CarConfigLabelStateType) => state.carConfigSettings.labels,
    (state: CarConfigLabelStateType) => !!state.commonSettings.query.showDictionaryKeys,
) as GetOptionalLabelType<CarConfigLabelStateType, CarConfigLabelType, CarConfigLabelParamType>;
export const CarConfigLabel = getLabelComponent(useCarConfigLabel) as LabelComponentType<
    CarConfigLabelType,
    CarConfigLabelParamType
>;
